import React, { useEffect, useState } from 'react';
import useWeb3Ctx from '../../hooks/useWeb3Ctx';

import { Box, Typography, Grid, Button } from '@mui/material';
import { SpinnerRoundFilled as Spinner } from 'spinners-react';

import Divider from '../../components/common/Divider';
import FullscreenModal from '../../components/common/FullscreenModal';
import title from '../../assets/images/title.png';
import Header from '../Header/Header';
import Card from '../common/Card.jsx';
import Title from '../common/Title';
import Footer from '../common/Footer';
import cardImage from '../../assets/images/card.svg';
import useAppCtx from '../../hooks/useAppCtx';
import useEnsTokens from '../../hooks/useEnsTokens';

const sx = {
  root: {
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    backgroundSize: 'cover',
    position: 'relative',
    transition: 'all .3s',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: '0 25px',
    mb: 4,
  },
  gridContainer: {
    mx: 'auto',
    maxWidth: '80%',
    justifyContent: 'center',
  },
  btn: {
    mx: 'auto',
    my: 4,
    fontSize: '20px',
    width: '180px',
    fontFamily: 'boucherie-block',
    borderRadius: '0px',
    minHeight: '65px',
    border: '2px solid #020100',
    backgroundColor: '#020100',
    backgroundClip: 'content-box',
    padding: '5px',
    '&:hover': {
      border: '2px solid #9D4C10',
      backgroundColor: '#9D4C10',
    },
    '&:active': {
      border: '2px solid #6A330A',
      backgroundColor: '#6A330A',
    },
  },

  imgContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '1073px',
    margin: 'auto',
  },
};

const CARDDATA = [
  {
    image: cardImage,
    name: 'Summer Maiden',
    id: '#01',
  },
  {
    image: cardImage,
    name: 'Summer Maiden',
    id: '#02',
  },
  {
    image: cardImage,
    name: 'Summer Maiden',
    id: '#03',
  },
  {
    image: cardImage,
    name: 'Summer Maiden',
    id: '#04',
  },
];

const Wallet = () => {
  const { metadata, metadataLoaded, loading } = useAppCtx();
  const { address, handleConnect } = useWeb3Ctx();
  const { getTokens } = useEnsTokens();

  const [isOpen, setOpen] = useState(false);
  const [fullscreenSrc, setFullscreenSrc] = useState(null);

  useEffect(() => {
    if (address && !metadataLoaded) {
      getTokens();
    }
  }, [address, metadataLoaded]);

  // useEffect(() => {
  //   setReversedMetadata(metadata.reverse());
  // }, [metadata]);

  useEffect(() => {
    if (!isOpen) {
      setFullscreenSrc(null);
    }
  }, [isOpen]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setFullscreenSrc(null);
    }
  }, [isOpen]);

  const setFullscreenSource = (src) => {
    setFullscreenSrc(src);
    setOpen(true);
  };

  return (
    <>
      <Header />

      <Box sx={sx.root}>
        <Box sx={sx.content}>
          <Box sx={sx.imgContainer}>
            <img
              src={title}
              style={{ width: '100%', marginTop: '0px' }}
              alt="title_decortion"
            />
          </Box>
          <Title text="Wallet" style={{ width: '25%' }} />
          {!address && (
            <Typography
              varian="body1"
              style={{ maxWidth: '728px', marginTop: '70px' }}
            >
              Connect your wallet to view your Equinox Collection
            </Typography>
          )}
          {!address && (
            <>
              <Button variant="outlined" onClick={handleConnect} sx={sx.btn}>
                Connect
              </Button>
            </>
          )}
        </Box>

        {loading && (
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Spinner color="black" />
          </Box>
        )}

        {address && (
          <>
            {!loading && metadata.length == 0 && (
              <Box
                variant="text"
                sx={{ my: 4, color: '#000000', textAlign: 'center' }}
              >
                Your wallet is empty.
              </Box>
            )}
            <Grid container sx={sx.gridContainer} columnSpacing={'14px'}>
              {metadata &&
                metadata.map((metadata) => {
                  return (
                    <Card
                      image={metadata.image}
                      name={metadata.series || 'Equinox Collection'}
                      id={metadata.id}
                      setFullscreenSource={setFullscreenSource}
                      md={3}
                      sx={12}
                      titleFontSize={35}
                      key={metadata.id}
                    />
                  );
                })}
            </Grid>
          </>
        )}

        <FullscreenModal
          setOpen={setOpen}
          isOpen={isOpen}
          imgSrc={fullscreenSrc}
        />
      </Box>
      <Footer />
    </>
  );
};

export default Wallet;
